import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=78b87752&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=78b87752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b87752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b87752')) {
      api.createRecord('78b87752', component.options)
    } else {
      api.reload('78b87752', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=78b87752&scoped=true&", function () {
      api.rerender('78b87752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/settings.vue"
export default component.exports